import { render, staticRenderFns } from "./HealthPlate.vue?vue&type=template&id=9b690106&"
import script from "./HealthPlate.vue?vue&type=script&lang=js&"
export * from "./HealthPlate.vue?vue&type=script&lang=js&"
import style0 from "./HealthPlate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports